import Marquee from "react-fast-marquee";
import { COMPANY } from "@/data/site";

export const SloganMarquee = () => {
  return (
    <section
      data-testid="slogan-marquee"
      className="bg-navy-950 border-y border-navy-700 py-8 overflow-hidden"
    >
      <Marquee speed={45} gradient={false}>
        <span className="font-display font-black uppercase text-5xl sm:text-7xl tracking-tighter text-stroke mx-8">
          {COMPANY.slogan}
        </span>
        <span className="font-display font-black uppercase text-5xl sm:text-7xl tracking-tighter text-brand mx-8">
          {COMPANY.slogan}
        </span>
      </Marquee>
    </section>
  );
};
